import { render, staticRenderFns } from "./StarRating.vue?vue&type=template&id=51e4f223&scoped=true"
import script from "./StarRating.vue?vue&type=script&lang=js"
export * from "./StarRating.vue?vue&type=script&lang=js"
import style0 from "./StarRating.vue?vue&type=style&index=0&id=51e4f223&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e4f223",
  null
  
)

export default component.exports